/**
 * VIV: colour-only names on variant cards.
 *
 * The EX Show Variants app splits a product into one card per colour and names
 * each card from its "product title - variant title" setting, which on this
 * theme prints the full variant ("- NAVY / 6 / Extra Petite - 92cm"). This
 * rewrites each split card to "product title - colour", matching the previous
 * theme. If the app setting is ever changed to "product title - color", this
 * script finds nothing to change and can be removed.
 */
(function () {
  const COLOUR_OPTION_NAMES = ['color', 'colour'];
  const CARD_SELECTOR = '.product-grid__item.eosh-rendered product-card';
  const TITLE_SELECTOR = '[class*="product_title"] p, .product-card__link .visually-hidden';
  const DEBOUNCE_MS = 100;

  function readProductsByHandle() {
    if (!window.variator || !window.variator.eoshVariatorData) return null;
    let data;
    try {
      data = JSON.parse(window.variator.eoshVariatorData);
    } catch (error) {
      return null;
    }
    const byHandle = {};
    Object.keys(data).forEach((id) => {
      const product = Array.isArray(data[id]) ? data[id][1] : null;
      if (product && product.handle) byHandle[product.handle] = product;
    });
    return byHandle;
  }

  function colourOf(product, variantId) {
    const optionNames = (product.options || []).map((option) =>
      String(typeof option === 'string' ? option : option.name || '').toLowerCase()
    );
    const colourIndex = optionNames.findIndex((name) => COLOUR_OPTION_NAMES.includes(name));
    if (colourIndex === -1) return null;
    const variant = (product.variants || []).find((item) => String(item.id) === String(variantId));
    if (!variant || !Array.isArray(variant.options)) return null;
    return variant.options[colourIndex] || null;
  }

  function renameCards() {
    const productsByHandle = readProductsByHandle();
    if (!productsByHandle) return;

    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (error) {
        return;
      }
      const handle = (url.pathname.split('/products/')[1] || '').split('/')[0];
      const variantId = url.searchParams.get('variant');
      const product = productsByHandle[handle];
      if (!product || !variantId) return;

      const colour = colourOf(product, variantId);
      if (!colour) return;

      const name = `${product.title} - ${colour}`;
      card.querySelectorAll(TITLE_SELECTOR).forEach((element) => {
        if (element.textContent.trim() !== name) element.textContent = name;
      });
    });
  }

  let timer = null;
  function scheduleRename() {
    window.clearTimeout(timer);
    timer = window.setTimeout(renameCards, DEBOUNCE_MS);
  }

  function start() {
    renameCards();
    // The app re-renders cards after load, on filter and sort, and on infinite scroll.
    new MutationObserver(scheduleRename).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('variator:initialized', scheduleRename);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
